import React from 'react';
import { CrosshairPosition } from '../shared';
import styles from './styles.module.scss';
import { stringDateWithTimeFromUtcNonNullable } from '@utils/convertor';

function getBasisDay(date: Date, basisDate: Date) {
    const timeDiff = date.getTime() - basisDate.getTime();
    return Math.floor(timeDiff / (1000 * 3600 * 24));
}

type Props = {
    crosshairPosition: CrosshairPosition | undefined;
    basisDate?: Date;
};

const CrosshairTooltip = ({ crosshairPosition, basisDate }: Props) => {
    if (crosshairPosition == null) {
        return null;
    }

    const dateString = stringDateWithTimeFromUtcNonNullable(crosshairPosition.value, 'DD-MMM-YYYY')!;

    const dayDiff = basisDate != null ? getBasisDay(crosshairPosition.value, basisDate) : null;

    return (
        <div className={styles.tooltip} data-plot-x={crosshairPosition.plotX + 10}>
            {dateString}
            {dayDiff != null && (
                <>
                    <br />
                    (Day {dayDiff})
                </>
            )}
        </div>
    );
};

export default CrosshairTooltip;
